var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 21.234 23.351"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Icon_feather-calendar",
  "data-name": "Icon feather-calendar",
  transform: "translate(-0.001)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1268",
  d: "M6.326-.01a1.007,1.007,0,0,0-.991,1.02V2.135H3.143A3.154,3.154,0,0,0,0,5.275v4.1A1.007,1.007,0,0,0,0,9.7v10.49a3.155,3.155,0,0,0,3.139,3.147h14.92a3.155,3.155,0,0,0,3.139-3.15V9.746a1.007,1.007,0,0,0,0-.422V5.275a3.154,3.154,0,0,0-3.139-3.139H15.878V1.01a1.007,1.007,0,1,0-2.014,0V2.135H7.349V1.01A1.007,1.007,0,0,0,6.326-.01ZM3.143,4.15H5.335V5.275a1.007,1.007,0,1,0,2.014,0V4.15h6.514V5.275a1.007,1.007,0,1,0,2.014,0V4.15h2.185a1.11,1.11,0,0,1,1.125,1.125V8.532H2.018V5.275A1.11,1.11,0,0,1,3.143,4.15Zm-1.125,6.4h17.17v9.648s0,0,0,.005a1.109,1.109,0,0,1-1.125,1.128H3.143A1.109,1.109,0,0,1,2.018,20.2s0,0,0-.005Z",
  transform: "translate(0.011 0.01)",
  fill: "#7b7b7b"
}))));
export { SvgCalendar as ReactComponent };
export default __webpack_public_path__ + "static/media/calendar.8b34ceb8469bd7cfffd50b42c274f3cc.svg";